<div class="message-container">
  @if (messages.length) {
    @for (message of messages; track message; let i = $index) {
      <div
        class="message"
        [class.user-message]="message.role === 'user'"
        [class.assistant-message]="message.role === 'assistant'">
        <!-- Show icon if assistant -->
        <div class="assistant-icon" *ngIf="message.role === 'assistant'">
          <mat-icon>account_circle</mat-icon>
        </div>
        <div class="content-container" [class.user-message]="message.role === 'user'">
          <!-- Content -->
          <div class="message-bubble" [class.new-message]="isNewMessage(message)" data-test-id="response-message">
            <!-- Render with citations for assistant messages, plain markdown for user messages -->
            @if (message.role === 'assistant') {
              <div class="message-with-citations">
                @for (
                  segment of getParsedContent(message.content[0].text).segments;
                  track trackBySegment($index, segment)
                ) {
                  <!-- Plain text segment -->
                  @if (segment.type === 'text') {
                    <markdown mermaid [data]="segment.content" [mermaidOptions]="mermaidChartingConfig"></markdown>
                  }
                  <!-- Block with citations (lists, headings, etc.) - keep intact -->
                  @if (segment.type === 'blockWithCitations') {
                    <!-- eslint-disable-next-line -->
                    <div class="block-with-citations" (click)="onBlockClick($event, segment.citationNumbers)">
                      <markdown
                        mermaid
                        [data]="segment.content"
                        [mermaidOptions]="mermaidChartingConfig"
                        [disableSanitizer]="true"></markdown>
                    </div>
                  }
                  <!-- Single citation -->
                  @if (segment.type === 'citation') {
                    <app-citation-link
                      [citationNumber]="segment.citation.number"
                      [tooltipText]="segment.citation.tooltipText"
                      [isAvailable]="segment.citation.isAvailable"
                      (citationClick)="onCitationClick($event)">
                    </app-citation-link>
                  }
                  <!-- Citation group (3+) -->
                  @if (segment.type === 'citationGroup') {
                    <app-citation-group [citations]="segment.citations" (citationClick)="onCitationClick($event)">
                    </app-citation-group>
                  }
                }
              </div>
            } @else {
              <markdown mermaid [data]="message.content[0].text" [mermaidOptions]="mermaidChartingConfig"></markdown>
            }
            <span class="timestamp">{{ message.timestamp | date: 'short' }}</span>
          </div>

          <!-- Show actions if reply is from assistant -->
          <div class="message-actions" *ngIf="!currentTypingMessage && !loading && message.role === 'assistant'">
              <button
              mat-icon-button
              matTooltip="Good response"
              (click)="updateAdvisorFeedback(FeedbackAdvisorType.POSITIVE, i)"
              [disabled]="getMessageFeedback(i) === FeedbackAdvisorType.POSITIVE">
                <mat-icon [ngClass]="getMessageFeedback(i) === FeedbackAdvisorType.POSITIVE ? 'material-symbols-filled' : 'material-symbols-outlined'"
                        >thumb_up</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="Needs improvement"
              (click)="updateAdvisorFeedback(FeedbackAdvisorType.NEGATIVE, i)"
              [disabled]="getMessageFeedback(i) === FeedbackAdvisorType.NEGATIVE">
              <mat-icon class="material-symbols-outlined"
                        [ngClass]="getMessageFeedback(i) === FeedbackAdvisorType.NEGATIVE ? 'negative-feedback' : ''"
                        >thumb_down</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Copy" (click)="copyToClipboard(message.content[0].text)">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="Create draft from response"
              (click)="draftSection(message.content[0].text)">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  } @else {
    <p class="placeholder-text">Prompt response will appear here...</p>
  }

  @if (loading) {
    <div class="message assistant-message">
      <div class="assistant-icon">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="message-bubble">
        <div class="generating-response-wrapper">
          <span>Generating response</span>
          <span class="ellipsis"></span>
        </div>
      </div>
    </div>
  }
  <!-- Display currently typing message -->
  @if (currentTypingMessage && isTyping) {
    <div class="message assistant-message">
      <div class="assistant-icon">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="message-bubble">
        <p>{{ currentTypingMessage.content[0].text }}<span class="cursor">▌</span></p>
        <span class="timestamp">{{ currentTypingMessage.timestamp | date: 'short' }}</span>
      </div>
    </div>
  }
</div>
<div class="spacer"></div>
